import Vue3Katex from 'vue3-katex'
import 'katex/dist/katex.min.css'

export default Vue3Katex
